import React from "react";
import jQuery from "jquery";
global.jQuery = jQuery;
global.jquery = jQuery;
global.$ = jQuery;

/**
 * Componente Toolbar que corresponde al navbar
 */
export default class Navbar extends React.Component {
  /**
   * Se inicializa el navbar.
   */
  componentDidMount() {
    // Check for click events on the navbar burger icon
    jQuery(".navbar-burger").click(function() {
      // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
      jQuery(".navbar-burger").toggleClass("is-active");
      jQuery(".navbar-menu").toggleClass("is-active");
    });
  }

  /**
   * Renderiza el componente
   */
  render() {
    return (
      <nav
        className="navbar is-primary"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="navbar-brand">
          {this.props.brand}
          <a
            role="button"
            className="navbar-burger burger"
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarBasicExample"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>

        <div id="navbarBasicExample" className="navbar-menu">
          {this.props.children}
        </div>
      </nav>
    );
  }
}
